import React, { useState } from "react";
import { Button, Grid, Typography, Box, TextField, Switch, FormControlLabel } from "@mui/material";
import LandlordPropertiesTable from "components/Tables/LandlordPropertiesTable";
import { styled } from "@mui/material/styles";
import { useLandlordProperties } from "services/hooks/rentals";
import { useSelector, useDispatch } from "react-redux";
import { FlexEnd } from "components/FlexBox/FlexBox";
import FormDialog from "components/modal";
import RentalsForm from "components/Forms/RentalsForm";
import { setPropertyId, setRefreshCount } from "state";
import { useNavigate } from "react-router-dom";
import * as yup from 'yup';
import axios from "axios";
import { baseURL } from "services/API";
import TopSnack from "components/TopSnack";


const TitleContainer = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const LandlordProperties = () => {
  const landlord = useSelector((state) => state.landlord);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [includeInactive, setIncludeInactive] = useState(false);
  const {landlordProperties,loading, error, setNewData} = useLandlordProperties(landlord.id, includeInactive);

  const handleIncludeInactiveChange = (event) => {
    setIncludeInactive(event.target.checked);
    setPage(0); // Reset to first page when filter changes
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rentalName, setRentalName] = React.useState("");
  const [rentalType, setRentalType] = React.useState("");
  const [rentalLocation, setRentalLocation] = React.useState("");
  const [rentalCity, setRentalCity] = React.useState("");
  const [security, setSecurity] = React.useState(false);
  const [gym, setGym] = React.useState(false);
  const [hospital, setHospital] = React.useState(false);
  const [mainRoad, setMainRoad] = React.useState(false);
  const [elevator, setElevator] = React.useState(false);
  const [swimmingPool, setSwimmingPool] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [openInactivate, setOpenInactivate] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState({})
  const [deleteMessage, setDeleteMessage] = React.useState("");
  const [deleteButton, setDeleteButton] = React.useState(false);
  const [inactivateMessage, setInactivateMessage] = React.useState("");
  const [errors, setErrors]= React.useState({});
  const [openSnack, setOpenSnack] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const [severity, setSeverity] = React.useState("");
  const [message, setMessage] = React.useState("");
  
  const [anchorEl, setAnchorEl] = useState(null);
  const [locationUrl, setLocationUrl] = React.useState("");
  const [payPercentage, setPayPercentage] = React.useState("");
  const [payPercentageEffectiveDate, setPayPercentageEffectiveDate] = React.useState("");
  const [dateInactivated, setDateInactivated] = React.useState("");

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack({ ...openSnack, open: false });
  };

  const handleNavigateUnits = (property_id) => {
    dispatch(setPropertyId(property_id));
    navigate("/propertyDetailsTab");
  };

  const handleRentalNameChange = (event) => {
		const {value} = event.target
		setRentalName(value);
		if (!value.trim()) {
      		setErrors((prev) => ({ ...prev, 'rental_name': `Property Name is required`}));
		} else {
			setErrors((prev) => ({ ...prev, "rental_name": "" }));
		}
	};

	const handleChangeRentalType = (event) => {
		const { value } = event.target;
		setRentalType(value);
		if (!value.trim()) {
      		setErrors((prev) => ({ ...prev, 'rental_type': `Select the property type`}));
		} else {
			setErrors((prev) => ({ ...prev, "rental_type": "" }));
		}
	};

	const handleRentalLocationChange = (event) => {
		const { value } = event.target;
		setRentalLocation(value);
		if (!value.trim()) {
      		setErrors((prev) => ({ ...prev, 'location_county': `Input a parish or county in the selected City`}));
		} else {
			setErrors((prev) => ({ ...prev, "location_county": "" }));
		}
	};


  const handleRentalCityChange = (event) => {
    const { value } = event.target;
		setRentalCity(value);
		if (!value.trim()) {
      		setErrors((prev) => ({ ...prev, 'location': `Input a City`}));
		} else {
			setErrors((prev) => ({ ...prev, "location": "" }));
		}
  };

  const handleLocationUrlChange = (event) => {
    setLocationUrl(event.target.value);
    if (!event.target.value.trim()) {
      setErrors((prev) => ({ ...prev, 'location_url': `Input a Google Map location URL` }));
    } else {
      setErrors((prev) => ({ ...prev, "location_url": "" }));
    }
  };

  const handlePayPercentageChange = (event) => {
    const { value } = event.target;
    setPayPercentage(value);
    // Optional: Add validation if needed
    if (value && (isNaN(value) || parseFloat(value) < 0 || parseFloat(value) > 100)) {
      setErrors((prev) => ({ ...prev, 'pay_percentage': `Pay percentage must be a number between 0 and 100` }));
    } else {
      setErrors((prev) => ({ ...prev, "pay_percentage": "" }));
    }
  };

  const handlePayPercentageEffectiveDateChange = (event) => {
    setPayPercentageEffectiveDate(event.target.value);
    if (!event.target.value.trim()) {
      setErrors((prev) => ({ ...prev, 'pay_percentage_effective_date': `Effective date is required when pay percentage is provided` }));
    } else {
      setErrors((prev) => ({ ...prev, "pay_percentage_effective_date": "" }));
    }
  };

  const handleSecurityCheck = (event) => {
    setSecurity(event.target.checked);
  };

  const handleSwimmingPoolCheck = (event) => {
    setSwimmingPool(event.target.checked);
  };

  const handleHospitalCheck = (event) => {
    setHospital(event.target.checked);
  };

  const handleMainRoadCheck = (event) => {
    setMainRoad(event.target.checked);
  };

  const handleElevatorCheck = (event) => {
    setElevator(event.target.checked);
  };

  const handleGymCheck = (event) => {
    setGym(event.target.checked);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setErrors({});
    setPayPercentage("");
    setPayPercentageEffectiveDate("");
  };

  const handleClickOpenDelete = async (item) => {
    setSelectedItem(item);
    try {
      const response = await axios.get(`${baseURL}/landlords/rentals/delete?rental_id=${item.id}`);
      if (response.data.status===200) {
        setDeleteMessage("Are you sure you want to delete this property?");
        setDeleteButton(true);
      }

      if (response.data.status===404) {
        setDeleteMessage(
        <>
          <Typography fontWeight={"bold"} color="red">This property can not currenty be deleted.</Typography>
          <Typography>Please remove any current tenants and try again</Typography>
        </>);
        setDeleteButton(false);
      }
      setAnchorEl(null);
      setOpenDelete(true);
    } catch (err) {
      setOpenSnack({ ...openSnack, open: true });
      setSeverity("error");
      setMessage("Property Delete failed, Please check property details");
    }
    
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleClickOpenInactivate = (item) => {
    setSelectedItem(item);
    setInactivateMessage("Are you sure you want to inactivate this property? The property will be marked as inactive but all data will be preserved.");
    setAnchorEl(null);
    setOpenInactivate(true);
  };

  const handleCloseInactivate = () => {
    setOpenInactivate(false);
    setDateInactivated("");
  };

  const handleDateInactivatedChange = (event) => {
    setDateInactivated(event.target.value);
  };

  const handleSubmitInactivate = async () => {
    try {
      // Format the date for the API
      // If date is provided, convert to ISO format with current time
      // If not provided, backend will use current timezone
      let dateInactivatedPayload = null;
      if (dateInactivated) {
        // Convert YYYY-MM-DD to ISO format with current time
        // Parse the date string and combine with current time
        const [year, month, day] = dateInactivated.split('-').map(Number);
        const now = new Date();
        const selectedDate = new Date(year, month - 1, day, now.getHours(), now.getMinutes(), now.getSeconds());
        // Format as ISO string
        dateInactivatedPayload = selectedDate.toISOString();
      }

      const response = await axios.post(
        `${baseURL}/landlords/rentals/delete?rental_id=${selectedItem.id}`,
        dateInactivatedPayload ? { date_inactivated: dateInactivatedPayload } : {}
      );

      setOpenSnack({ ...openSnack, open: true });
      setSeverity("success");
      setMessage("Property Inactivated Successfully");
      setOpenInactivate(false);
      setDateInactivated("");
      setNewData(true);
      dispatch(setRefreshCount());
    } catch (err) {
      setOpenSnack({ ...openSnack, open: true });
      setSeverity("error");
      setMessage(err.response?.data?.error || "Property inactivation failed. Please try again.");
    }
  };

  const handleSubmitDelete = async () => {
    try {
      const response = await axios.delete(`${baseURL}/landlords/rentals/delete?rental_id=${selectedItem.id}`);

      setOpenSnack({ ...openSnack, open: true });
      setSeverity("success");
      setMessage("Property Deleted Successfully");
      setOpenDelete(false);
      setNewData(true);
      dispatch(setRefreshCount());
    } catch (err) {
      setOpenSnack({ ...openSnack, open: true });
      setSeverity("error");
      setMessage("Property Delete failed, Please check property details");
    }
  };


  const propertySchema = yup.object().shape({
		rental_name: yup.string().required("Please enter the property name"),
		location: yup.string().required("Input a City"),
    location_county: yup.string().required("Input a parish or county in the selected City"),
		rental_type: yup.string().required("Select the property type"),
	});

  const handleRentalFormSubmit = async () => {
    // Validate that if pay_percentage is provided, effective_date must also be provided
    if (payPercentage && !payPercentageEffectiveDate) {
      setErrors((prev) => ({ ...prev, pay_percentage_effective_date: "Effective date is required when pay percentage is provided" }));
      return;
    }

    try {
			await propertySchema.validate(
        {
          rental_name: rentalName,
          rental_type: rentalType,
          location: rentalCity,
          location_county: rentalLocation,
          has24_security: security,
          has_gym: gym,
          has_swimming_pool: swimmingPool,
          has_elevator: elevator,
          hospital_access: hospital,
          main_road_access: mainRoad,
        },
        { abortEarly: false }
      );
		} catch (error) {
			const newError = {}
			error.inner.forEach(err => {
				newError[err.path]=err.message
			})
			setErrors(newError)
			return
		}

    try {
      const payload = {
        related_landlord: landlord.id,
        rental_name: rentalName,
        rental_type: rentalType,
        location: rentalCity,
        location_county: rentalLocation,
        location_url: locationUrl,
        has24_security: security,
        has_gym: gym,
        has_swimming_pool: swimmingPool,
        has_elevator: elevator,
        hospital_access: hospital,
        main_road_access: mainRoad,
        pay_percentage: payPercentage ? parseFloat(payPercentage) : null,
      };

      // Add pay_percentage_effective_date if pay_percentage is provided
      if (payPercentage && payPercentageEffectiveDate) {
        payload.pay_percentage_effective_date = payPercentageEffectiveDate;
      }

      const response = await axios.post(`${baseURL}/landlords/rentals`, payload);

      setOpenSnack({...openSnack, open: true});
      setSeverity("success");
      setMessage("Property Added Successfully");
      setOpen(false);
      dispatch(setRefreshCount());
      handleNavigateUnits(response.data.data.id);
    } catch (err) {
      setOpenSnack({ ...openSnack, open: true });
      setSeverity("error");
      setMessage("Property Addition failed, Please check property details");
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (loading) return <Typography>Loading...</Typography>;
  if (error) return <Typography>Error loading properties</Typography>;

  return (
    <Box m="20px">
      <FlexEnd sx={{ marginBottom:"10px",  flexDirection:"row", justifyContent:"space-between", alignItems:"center" }}>
        <FormControlLabel
          control={
            <Switch
              checked={includeInactive}
              onChange={handleIncludeInactiveChange}
              color="primary"
            />
          }
          label={includeInactive ? "Showing All Properties (Active & Inactive)" : "Showing Active Properties Only"}
        />
        <Button onClick={()=>handleClickOpen()} variant="contained" color="primary">
          Add Property
        </Button>
      </FlexEnd>
      {landlordProperties && (
        <LandlordPropertiesTable
          properties={landlordProperties}
          page={page}
          rowsPerPage={rowsPerPage}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleClickOpenDelete={handleClickOpenDelete}
          handleClickOpenInactivate={handleClickOpenInactivate}
          handleNavigateUnits={handleNavigateUnits}
        />
      )}
      <FormDialog
        open={open}
        handleClose={handleClose}
        enableActions={true}
        content={
          <RentalsForm
            rentalType={rentalType}
            rentalCity={rentalCity}
            locationUrl={locationUrl}
            payPercentage={payPercentage}
            payPercentageEffectiveDate={payPercentageEffectiveDate}
            handleRentalNameChange={handleRentalNameChange}
            handleChangeRentalType={handleChangeRentalType}
            handleRentalLocationChange={handleRentalLocationChange}
            handleRentalCityChange={handleRentalCityChange}
            handleLocationUrlChange={handleLocationUrlChange}
            handlePayPercentageChange={handlePayPercentageChange}
            handlePayPercentageEffectiveDateChange={handlePayPercentageEffectiveDateChange}
            handleSecurityCheck={handleSecurityCheck}
            handleGymCheck={handleGymCheck}
            handleSwimmingPoolCheck={handleSwimmingPoolCheck}
            handleElevatorCheck={handleElevatorCheck}
            handleHospitalCheck={handleHospitalCheck}
            handleMainRoadCheck={handleMainRoadCheck}
            errors={errors}
            security={security}
            gym={gym}
            swimmingPool={swimmingPool}
            elevator={elevator}
            hospital={hospital}
            mainRoad={mainRoad}
          />
        }
        title={"Add all Property Details"}
        handleSubmit={handleRentalFormSubmit}
        buttonText="submit"
      />
      <FormDialog
        open={openDelete}
        handleClose={handleCloseDelete}
        enableActions={deleteButton}
        content={deleteMessage}
        title={"Delete all Property Details"}
        handleSubmit={handleSubmitDelete}
        buttonText="Yes, Delete"
      />
      <FormDialog
        open={openInactivate}
        handleClose={handleCloseInactivate}
        enableActions={true}
        content={
          <Box>
            <Typography sx={{ marginBottom: 2 }}>
              {inactivateMessage}
            </Typography>
            <TextField
              label="Inactivation Date"
              type="date"
              value={dateInactivated}
              onChange={handleDateInactivatedChange}
              InputLabelProps={{ shrink: true }}
              fullWidth
              sx={{ marginTop: 2 }}
              helperText="Leave empty to use current date and time"
            />
          </Box>
        }
        title={"Inactivate Property"}
        handleSubmit={handleSubmitInactivate}
        buttonText="Yes, Inactivate"
      />

      <TopSnack
        vertical={openSnack.vertical}
        horizontal={openSnack.horizontal}
        open={openSnack.open}
        handleCloseSnack={handleCloseSnack}
        message={message}
        severity={severity}
      />
    </Box>
  );
};

export default LandlordProperties;
